/**
 * OrgAdmin → Overview. Sprint 1 placeholder; real fields (address, phone,
 * billing) arrive in Sprint 2 when OrganizationSettings wiring lands.
 */
export function OverviewPage() {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="[font:var(--type-page-title)] text-[var(--ink-body)]">Organisation overview</h1>
      <p className="[font:var(--type-body)] text-[var(--ink-secondary)]">
        This screen will show your organisation's profile, contacts, and subscription
        state. Wired in Sprint 2.
      </p>
    </div>
  );
}
